export const LIVE_RECORDED = "live + recorded";

export const LIVE = "live";
